import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import RecordList from './RecordList';
import Pagination from './Pagination';
import details from './models';
import Header from './RecordTableHeader';

class RecordTable extends React.PureComponent {
  selectAll = (e) => {
    const {
      records,
      initialSelect,
      setAllSelectCheckbox,
      selectAllAgents,
      setInitialSelect,
      toggleUserSidebar,
      deselectAllAgents,
    } = this.props;

    if (e.target.checked) {
      setAllSelectCheckbox(true);
      selectAllAgents(records);
      setInitialSelect(false);
      if (initialSelect) {
        toggleUserSidebar(true);
      }
    } else {
      setAllSelectCheckbox(false);
      deselectAllAgents(records);
      setInitialSelect(true);
    }
  };

  render() {
    const {
      columnFilters,
      callFilterOpen,
      // setAllSelectCheckbox,
      // selectedAgents,
      allSelectCheck,
    } = this.props;

    // const agentsDisplayed = Array.from(new Set(recordPage.map((a) => a.username)));
    // const selected = Array.from(new Set(selectedAgents.map((a) => a.username)));
    // agentsDisplayed.forEach((username) => {
    //   if (selected.includes(username)) {
    //     setAllSelectCheckbox(true);
    //   } else {
    //     setAllSelectCheckbox(false);
    //   }
    // });

    return (
      <>
        <Table
          size="sm"
          className="font-small mb-0 text-nowrap"
          style={{
            minWidth: '83vw',
            overflow: 'scroll',
            display: 'block',
            position: 'relative',
            // Height of expanded call filter dropdown
            height: callFilterOpen
              ? 'calc(100vh - 360px - 293px)'
              : 'calc(100vh - 360px)',
            outline: '1px solid black',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <thead
            className="sticky-top bg-gray"
            style={{
              top: '1px',
              zIndex: '2',
              height: '32px',
              outline: '1px solid black',
            }}
          >
            <tr>
              <th className="text-center ps-1 pe-0" style={{ opacity: '0' }}>
                <div className="btn p-0">
                  <input
                    className="form-control"
                    type="checkbox"
                    id="select-all"
                    onChange={this.selectAll}
                    checked={allSelectCheck}
                  />
                </div>
              </th>
              {
                details.map((model) => {
                  const filterIdx = columnFilters.findIndex((cf) => cf.id === model.id);
                  const filterValue = filterIdx === -1 || columnFilters[filterIdx].value;
                  if (filterValue) {
                    return (
                      <Header model={model} key={model.id} />
                    );
                  }
                  return null;
                })
              }
            </tr>
          </thead>

          <RecordList />
        </Table>
        <div className="record-pagination">
          <Pagination />
        </div>
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  recordPage: store.records.recordPage,

  columnFilters: store.records.columnFilters,
  callFilterOpen: store.records.callFilterOpen,
  selectedAgents: store.records.selectedAgents,
  sortBy: store.records.sortBy,
  sortInverse: store.records.sortInverse,
  searchTerm: store.records.searchTerm,
  allSelectCheck: store.records.allSelectCheck,
  initialSelect: store.records.initialSelect,
});

const mapDispatchToProps = {
  setAllSelectCheckbox: (payload) => ({ type: 'SET_ALL_SELECT_CHECKBOX', payload }),
  selectAllAgents: (payload) => ({ type: 'SELECT_ALL_AGENTS', payload }),
  setInitialSelect: (payload) => ({ type: 'SET_INITIAL_SELECT', payload }),
  toggleUserSidebar: (payload) => ({ type: 'TOGGLE_USER_SIDEBAR', payload }),
  deselectAllAgents: (payload) => ({ type: 'DESELECT_ALL_AGENTS', payload }),
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordTable);
